const countDot = {
    height: {
        XSMALL: '0.75rem',
        SMALL: '0.875rem',
        MEDIUM: '1rem',
    },
    wPadding: {
        XSMALL: '0.1875rem',
        SMALL: '0.25rem',
        MEDIUM: '0.3125rem',
    },
};
export default countDot;
//# sourceMappingURL=countDot.js.map